import { render, staticRenderFns } from "./OptionShowDocumentsTab.vue?vue&type=template&id=39b4136c"
import script from "./OptionShowDocumentsTab.vue?vue&type=script&lang=ts"
export * from "./OptionShowDocumentsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports